import { render, staticRenderFns } from "./ChallengeInfo.vue?vue&type=template&id=31d2cf3a&scoped=true"
import script from "./ChallengeInfo.vue?vue&type=script&lang=js"
export * from "./ChallengeInfo.vue?vue&type=script&lang=js"
import style0 from "./ChallengeInfo.vue?vue&type=style&index=0&id=31d2cf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2cf3a",
  null
  
)

export default component.exports